query GetMeetingsSidebarCounts {
    meetingsSidebarCounts {
        zoom {
            value
            suffix
            prefix
            formatted
        }
        googleMeet {
            value
            suffix
            prefix
            formatted
        }
        teams {
            value
            suffix
            prefix
            formatted
        }
    }
}
